import { useMemo } from 'react';

import { mapToMedicalPlanCoversLovs } from '../helpers';
import { useGetMedicalPlanCovers } from '../proposal.slice';

export function useMedicalPlanCoversLovs(planID: string) {
  const { data } = useGetMedicalPlanCovers({
    variables: { planID },
    skip: !planID,
    fetchPolicy: 'cache-and-network'
  });

  const allOptions = useMemo(() => mapToMedicalPlanCoversLovs(data), [data]);

  return { allOptions };
}
